<app-sidenav-menu [links]="sidenavLinks$ | async" [hasStatus]="true"></app-sidenav-menu>
